import { z } from 'zod';

/** Named boundaries shared by authoring jobs and their operator-visible progress. */
export const authoringStageSchema = z.enum(['queued', 'verifying-recording', 'deriving-references',
  'importing', 'calibrating', 'compiling', 'storing', 'verifying-host', 'publishing', 'committing']);
export type AuthoringStage = z.infer<typeof authoringStageSchema>;

const counter = z.number().int().nonnegative().safe();
/** Closed telemetry allowlist: never accept arbitrary labels, payloads or signed URLs. */
export const authoringMetricSchema = z.object({
  operationId: z.string().uuid(), stage: authoringStageSchema, durationMs: counter,
  storageBytesRead: counter, storageBytesWritten: counter, decoderRuns: counter,
  cacheHits: counter, cacheMisses: counter, queueWaitMs: counter,
}).strict();
export type AuthoringMetric = z.infer<typeof authoringMetricSchema>;
